import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../../context/global_context'
import { createSearchParams, useParams } from 'react-router-dom'
import {
  CapitalHarnessContext,
  SET_CAPITAL_HARNESS_PLUGIN_DATA,
  SET_SHOW_HIDE_COPY_POPUP,
  SET_SHOW_HIDE_DETAILS_POPUP,
  SET_SHOW_HIDE_FORM_POPUP,
  SET_UPLOAD_FILE_STATUS,
} from './context/context'
import Button from '../../../common/Button'
import InputText from '../../../common/InputText'
import {
  deleteRequest,
  getRequest,
  postRequest,
} from '../../../../services/base'
import LinkWithStatus from '../../../common/LinkWithStatus'
import Pagination from '../../../common/Pagination'
import NoRecordsFound from '../../../common/NoRecordsFound'
import CapitalHarnessForm from './form'
import CapitalHarnessRow from './CapitalHarnessRow'
import CapitalHarnessDetails from './detail'
import { ProgresSpinner } from '../../../common/ProgresSpinner'
import { CloudUpload, Download } from '@styled-icons/boxicons-solid'
import ErrorCard from '../../../common/ErrorCard'
import DropDownMenu from '../../../common/DropDownMenu'
import CloneDataFromPopup from './clone_from_model'
import { getSessionStorageData } from '../../../../utils/SessionStorage'

const CapitalHarness = () => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(NavContext)
  const [isAllowed, setIsAllowed] = useState(true)

  const [capitalHarnessState, capitalHarnessDispatch] = useContext(
    CapitalHarnessContext
  )

  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({})
  const currentUrl = useRef(
    `/api/plugin/capital_harness/?vehicle=${vehicle}&search=${searchValue}`
  )

  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / Plugin / Capital Harness Plugin`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })

    // getHarnessList()
    fetchCapHarnessStatusInterval()
  }, [])

  const getHarnessList = async () => {
    let response = await getRequest(currentUrl.current)
    capitalHarnessDispatch({
      type: SET_CAPITAL_HARNESS_PLUGIN_DATA,
      data: response.results,
    })
    setPagination(response.pagination)
  }

  const deleteCapitalHarness = async (capital_harness_id) => {
    if (window.confirm('Are you sure to delete Capital Harness file') == true) {
      dispatch({
        type: 'loader',
        data: {
          caption: 'Deleting Selected Capital Harness ...',
          showLoader: true,
        },
        notification: {},
      })
      let res = await deleteRequest(
        `/api/plugin/capital_harness/${capital_harness_id}/?vehicle=${vehicle}`
      )
      getHarnessList(null)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'Capital Harness files Successfully deleted!',
        },
      })
    }
  }

  const fetchCapHarnessStatusInterval = async () => {
    let res = await getRequest(
      `/api/plugin/capital_harness/upload_status_check/${vehicle}/?vehicle=${vehicle}`
    )
    if (!res?.is_allowed) {
      setIsAllowed(false)
    } else {
      if (res?.status) {
        capitalHarnessDispatch({
          type: SET_UPLOAD_FILE_STATUS,
          data: res.data,
        })
        if (res.data) {
          setTimeout(() => {
            fetchCapHarnessStatusInterval()
          }, 10000)
        } else {
          getHarnessList()
        }
      }
    }
  }

  const downloadCapitalHarnessFiles = async (option_value) => {
    let formData = new FormData()
    if (option_value == 'all') {
      formData.append('download_files', 'all')
    } else {
      capitalHarnessState.selectedIds.forEach((element) => {
        formData.append('download_files', element)
      })
    }

    formData.append('vehicle', vehicle)

    let res = await postRequest(
      `/api/plugin/capital_harness/bulk/download/`,
      formData,
      true
    )
    if (res?.msg) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
          loader: true,
        },
      })
    } else {
      const url = window.URL.createObjectURL(new Blob([res]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${vehicle}_def.zip`)
      document.body.appendChild(link)
      link.click()
      link.remove()

      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File downloaded successfully',
          loader: true,
        },
      })
    }
  }

  const reRunFileGeneration = async (capital_harnes_obj) => {
    if (
      window.confirm(
        `Are you sure want to run file generation process for ${capital_harnes_obj?.name}`
      ) == true
    ) {
      fetchCapHarnessStatusInterval()
      dispatch({
        type: 'loader',
        data: {
          caption: 'Generation Capital Harness Files...',
          showLoader: true,
        },
        notification: {},
      })
      let res = await postRequest(
        `/api/plugin/capital_harness/run_file_generation/${vehicle}/${capital_harnes_obj?.id}/`
      )
      if (res?.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: res?.msg,
            loader: true,
          },
        })
      } else {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
            loader: true,
          },
        })
      }
    }
  }

  return (
    <div>
      {!isAllowed ? (
        <ErrorCard
          title={'Not Permitted'}
          sub_title={'This Feature is not configured for your make'}
        />
      ) : (
        <>
          {capitalHarnessState?.showCopyPopup && <CloneDataFromPopup />}
          {capitalHarnessState?.showUploadPopup && (
            <CapitalHarnessForm
              getHarnessList={getHarnessList}
              fetchCapHarnessStatusInterval={fetchCapHarnessStatusInterval}
            />
          )}
          {capitalHarnessState?.showDetailsPopup && <CapitalHarnessDetails />}

          <div className="w-full">
            <form
              className="flex flex-col w-full space-y-2 pb-2"
              acceptCharset="UTF-8"
              onSubmit={(e) => {
                e.preventDefault()
              }}
            >
              <div
                className={`flex space-x-5 justify-between content-center items-center`}
              >
                <div className="flex items-center w-1/2">
                  <div className="flex items-center w-full">
                    <InputText
                      name="search_value"
                      placeholder={`Search Capital Harness By Name`}
                      className={`w-100`}
                      value={searchValue}
                      isFullSize={true}
                      type="search"
                      onChange={(value) => {
                        setSearchValue(value)
                      }}
                      isRequired={false}
                    />
                    <Button
                      className={`cursor-pointer btn my-4 justify-end`}
                      text={`Search`}
                      onClick={() => {
                        currentUrl.current = `/api/plugin/capital_harness/?vehicle=${vehicle}&search=${searchValue}`
                        getHarnessList('')
                      }}
                    />
                  </div>
                </div>

                {capitalHarnessState?.in_process_upload_files && (
                  <LinkWithStatus
                    href={`/vehicles/${vehicle.vehicle_id}/progress`}
                    className="btn py-2 px-3 flex"
                    title="Progress"
                    onClickFunc={() => {}}
                    key={`upload-capital-harness-file`}
                  >
                    <ProgresSpinner caption="File Upload In Progress" />
                    <CloudUpload
                      size="1.5rem"
                      color="white"
                      key={`upload-capital-harness-file-status`}
                    />
                  </LinkWithStatus>
                )}

                <div className="flex items-center gap-2">
                  <DropDownMenu
                    items={[
                      { name: 'Download All Files', value: 'all' },
                      {
                        name: 'Download Selected Files',
                        value: 'download_selected_files',
                      },
                    ]}
                    onClick={(item) => {
                      downloadCapitalHarnessFiles(item.value)
                    }}
                    showMenu={capitalHarnessState?.selectedIds?.length > 0}
                    key={`download-capital-harness-file`}
                  >
                    <LinkWithStatus
                      href={`/vehicles/${vehicle.vehicle_id}/capital_harness`}
                      className="btn py-2 px-3"
                      title="Download"
                      onClickFunc={() => {}}
                      key={`download-capital-harness-file-link`}
                    >
                      <Download
                        size="1.5rem"
                        color="white"
                        key={`download-capital-harness-file-icon`}
                      />
                    </LinkWithStatus>
                  </DropDownMenu>

                  <LinkWithStatus
                    href={`/administration/capital_harness/new`}
                    className={
                      'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
                    }
                    title="Upload New File"
                    onClickFunc={() => {
                      capitalHarnessDispatch({
                        type: SET_SHOW_HIDE_FORM_POPUP,
                        data: true,
                      })
                    }}
                  />
                </div>
              </div>
            </form>
          </div>

          <div className="font-light">
            <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
              <div className="flex w-4/12 pl-6 items-center">Name</div>
              <div className="flex w-3/12 pl-6 items-center">Abbreviation</div>
              <div className="flex w-3/12 pl-6 items-center">Date</div>
              <div className="flex w-2/12 pl-6 items-center"></div>
            </div>
          </div>

          {capitalHarnessState?.data?.map((capital_harness, index) => {
            return (
              <CapitalHarnessRow
                {...capital_harness}
                onDelete={() => {
                  deleteCapitalHarness(capital_harness.id)
                }}
                key={`capital-harness-${index}`}
                onShowDetails={() => {
                  capitalHarnessDispatch({
                    type: SET_SHOW_HIDE_DETAILS_POPUP,
                    data: capital_harness,
                  })
                }}
                onShowCopyModal={(value) => {
                  capitalHarnessDispatch({
                    type: SET_SHOW_HIDE_COPY_POPUP,
                    data: capital_harness,
                    showCopyPopup: true,
                    selectedType: value,
                  })
                }}
                reRunFileGeneration={() => {
                  reRunFileGeneration(capital_harness)
                }}
              />
            )
          })}

          {capitalHarnessState?.data?.length < 1 && (
            <NoRecordsFound
              caption={'Sales Code Complexity not found'}
              loading={false}
            />
          )}
          <div className="py-6">
            <Pagination
              context={pagination}
              onClickNext={(e) => {
                currentUrl.current = e
                getHarnessList()
              }}
              onClickPrev={(e) => {
                currentUrl.current = e
                getHarnessList()
              }}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default CapitalHarness
